import { StandardEvents } from '@shopify/events';

let updateVersion = 0;

function renderCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-wg-cart-count]').forEach((element) => {
    element.textContent = String(count);
  });
}

async function refreshCount() {
  const version = ++updateVersion;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    if (version === updateVersion) renderCount(cart.item_count);
  } catch {
    // Keep the last confirmed count if the cart cannot be refreshed.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const version = ++updateVersion;
  if (!event.promise) {
    void refreshCount();
    return;
  }
  event.promise.then(({ cart, detail }) => {
    if (version !== updateVersion) return;
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (Number.isInteger(count) && count >= 0) renderCount(count);
    else void refreshCount();
  }).catch((error) => {
    if (version === updateVersion && error?.name !== 'AbortError') void refreshCount();
  });
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) void refreshCount();
});
